import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-how-it-works',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './how-it-works.component.html',
  styleUrl: './how-it-works.component.css'
})
export class HowItWorksComponent {
  steps = [
    {
      title: 'Consultation',
      desc: 'Our experts analyze your current telephony infrastructure and communication needs.',
      icon: '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>'
    },
    {
      title: 'Custom Design',
      desc: 'We architect a tailored IP PBX solution that integrates with your existing workflow.',
      icon: '<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline>'
    },
    {
      title: 'Seamless Migration',
      desc: 'We port your numbers and deploy hardware with zero business downtime.',
      icon: '<path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path>'
    },
    {
      title: 'Go Live & Support',
      desc: 'Your team is onboarded, backed by our 24/7 dedicated enterprise support.',
      icon: '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>'
    }
  ];
}
